import { Checkbox } from '@sgme/ui';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

export function NdfCheckbox({ isNdf }: { isNdf: boolean }): ReactElement {
  const { formatMessage } = useIntl();

  return (
    <Checkbox
      label={formatMessage({ id: 'CashTile.NDFCheckbox.label' })}
      checked={isNdf}
      disabled={true}
      dataE2e="ndf-checkbox"
    />
  );
}
